module.exports = __webpack_public_path__ + "static/media/transmission-fluid-exchange.71650f05.svg";